<script>
export default {
  name: 'RobTable',
  props: {
    items: Array,
    loading: Boolean,
    error: Object,
    selectedAssetData: Object,
    confirmingDeleteId: [Number, String],
  },
  data() {
    return {
      robTableFields: [
        { key: 'mrobStartTime', label: 'Start Time', formatter: 'formatDateToLocal' },
        { key: 'mrobEndTime', label: 'End Time', formatter: 'formatDateToLocal' },
        { key: 'mrobInitialValue', label: 'Initial Value', formatter: (value) => this.formatNumber(value) },
        { key: 'mrobCreatedUserId', label: 'Created By' },
        { key: 'mrobCreatedTime', label: 'Created At', formatter: 'formatDateToLocal' },
        { key: 'actions', label: 'Actions' },
      ],
    };
  },
  methods: {
    formatNumber(value) {
      if (value === null || typeof value === 'undefined') return '';
      const numberValue = Number(value);
      if (Number.isNaN(numberValue)) return value;
      return new Intl.NumberFormat('id-ID', { minimumFractionDigits: 1, maximumFractionDigits: 5 }).format(numberValue);
    },
    formatDateToLocal(dateString) {
      if (!dateString) return '';
      const date = new Date(`${dateString.replace(' ', 'T')}Z`);
      const dateOptions = { day: 'numeric', month: 'long', year: 'numeric' };
      const timeOptions = {
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
      };
      const formattedDate = date.toLocaleDateString('id-ID', dateOptions);
      const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
      return `${formattedDate}, ${formattedTime}`;
    },
  },
};
</script>

<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 v-if="selectedAssetData" class="mb-0">ROB Profile {{ selectedAssetData.massName }}</h5>
      <b-button v-if="canCreate('master_rob_rob')" variant="primary" @click="$emit('add-new')">Add New ROB</b-button>
    </div>

    <div v-if="loading" class="text-center">
      <p>Loading...</p>
    </div>
    <div v-else-if="error" class="alert alert-danger">
      Failed to load data. Please try again.
    </div>
    <b-table v-else striped hover responsive :items="items" :fields="robTableFields" show-empty>
      <template #empty>
        <div class="text-center">
          <p>No data available for this asset.</p>
        </div>
      </template>
      <template #cell(actions)="data">
        <b-button variant="info" size="sm" class="mr-1" @click="$emit('view-details', data.item)">Detail</b-button>
        <b-button v-if="canUpdate('master_rob_rob')" variant="warning" size="sm" class="mr-1"
          @click="$emit('edit-rob', data.item)">Edit</b-button>
        <b-button v-if="canDelete('master_rob_rob')" size="sm"
          :variant="confirmingDeleteId === data.item.mrobId ? 'danger' : 'outline-danger'"
          @click="$emit('delete-rob', data.item)" @mouseleave="$emit('update:confirmingDeleteId', null)">
          {{ confirmingDeleteId === data.item.mrobId ? 'Confirm?' : 'Delete' }}
        </b-button>
      </template>
    </b-table>
  </div>
</template>
